import styled from 'styled-components'

import windowGray from './images/browser_gray.png'
import windowPink from './images/browser_pink.png'

export const Container = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 1.5rem;
  margin-top: 1.5rem;
  z-index: 99999;
  [data-sl-alert] {
    box-shadow: var(--sl-shadow-1);
  }
`
export const RedirectingHeading = styled.h1``
export const RedirectingWrapper = styled.div``
export const RedirectingTextBox = styled.div`
  width: calc(100% - 3rem);
  margin: 1rem auto 4rem;
  max-width: 480px;
  text-align: center;
`

export const CountdownSeconds = styled.div`
  font-size: 1.5rem;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  width: 100%;
  text-align: center;
  height: 0;
  z-index: 999;
  line-height: 0;
`

export const RedirectingAnimationBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2.875rem;
  margin-top: 3;
`

type WindowBoxProps = {
  elevate?: 0 | 1 | 2 | 3
}

const elevateMod = (props: WindowBoxProps) => {
  switch (props.elevate as unknown) {
    case 1:
      return `
            filter: drop-shadow(0 6px 8px rgba(0, 0, 0, 0.14));
            transform: scale(1);
            z-index: 1;
        `
    case 2:
      return `
            filter: drop-shadow(0 10px 10px rgba(0, 0, 0, 0.2));
            transform: scale(1.1) translateX(calc(-100% + 3rem));
            z-index: 2;
        `
    case 0:
    default:
      return `
        filter: drop-shadow(0 3px 6px rgba(0, 0, 0, 0.08));
        transform: scale(0.9) translateX(calc(100% - 3rem));
        z-index: 0;
        `
  }
}

export const WindowBoxGray = styled.div<WindowBoxProps>`
  width: 15.625rem;
  height: 11.25rem;
  background-image: url(${windowGray});
  background-size: 100% 100%;
  font-size: 1rem;
  overflow: hidden;
  padding-top: 2.1rem;
  line-height: calc(11.25rem - 2.1rem * 2);
  text-align: center;
  transition: 0.8s;
  ${elevateMod}
`

export const WindowBoxPink = styled.div<WindowBoxProps>`
  width: 15.625rem;
  height: 11.25rem;
  background-image: url(${windowPink});
  background-size: 100% 100%;
  font-size: 1rem;
  overflow: hidden;
  padding-top: 2.1rem;
  line-height: calc(11.25rem - 2.1rem * 2);
  text-align: center;
  transition: 0.8s;
  ${elevateMod}
`

export const Arrow = styled.div`
  width: 4.625rem;
  height: 3px;
  background: #e7e9ee;
  position: relative;
  border-radius: 0 10px 10px 0;
  &::before {
    content: '';
    display: block;
    width: 1rem;
    height: 3px;
    background: blue;
    border-radius: 100px;
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    transform-origin: right bottom;
    transform: rotate(45deg);
    background: #e7e9ee;
  }
  &::after {
    content: '';
    display: block;
    width: 1rem;
    height: 3px;
    background: red;
    border-radius: 100px;
    position: absolute;
    right: 0;
    top: -1px;
    bottom: 0;
    transform-origin: right top;
    transform: rotate(-45deg);
    background: #e7e9ee;
  }
`

export const CountdownWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
`
